module.exports = __webpack_public_path__ + "img/file-pdf.0b657f40.svg";